export default __webpack_public_path__ + "static/media/result_body_overweight.b3c04648.jpg";